import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { label: '首页', href: '/' },
    { label: '韩漫', href: '/category/korean' },
    { label: '日漫', href: '/category/japanese' },
    { label: '国漫', href: '/category/chinese' },
  ],
  support: [
    { label: '关于我们', href: '/about' },
    { label: '联系我们', href: '/about#contact' },
    { label: '常见问题', href: '/#faq' },
  ],
  hotTags: ['韩漫推荐', '日漫排行', '国漫精选', '热血漫画', '恋爱漫画', '奇幻漫画', '武侠漫画', '穿越漫画'],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <span className="font-heading text-2xl text-primary-400">可乐漫画</span>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              可乐漫画📰按类型精选韩漫、日漫、国漫，好看的漫画大全一网打尽，热门漫画免费在线看，下拉式流畅阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.navigation.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">帮助与支持</h4>
            <div className="flex flex-col gap-2">
              {footerLinks.support.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门标签</h4>
            <div className="flex flex-wrap gap-2">
              {footerLinks.hotTags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1 text-xs rounded-full bg-foreground-800 text-foreground-300 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 可乐漫画 KeleManga. 本站所有漫画均来自网络，版权归原作者所有。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-weibo-line"></i></div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-wechat-line"></i></div>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
              <div className="w-5 h-5 flex items-center justify-center"><i className="ri-bilibili-line"></i></div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}